var React = require('react');

function WhiteBgDetailInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\r\n\t\t\t.abc{fill:#fff;opacity:0.48;}\r\n\t\t")),React.createElement("path",{"className":"abc","d":"M387.678,456.463,422.205,322.5a645.7,645.7,0,0,0,669.81-256A637.049,637.049,0,0,0,1132.771,0V250.959C989.2,402.631,790.284,482.524,587.164,482.536A776.271,776.271,0,0,1,387.678,456.463ZM168.723,360.432,237.74,252.389a677.1,677.1,0,0,0,90.977,41.586L275.684,417.413A789.569,789.569,0,0,1,168.723,360.432ZM0,217.3l87.031-73.754c14.707,11.846,30.987,25.236,49.657,39.635,0,0,12.481,10.287,27.456,21.436L83.7,298.023A774.684,774.684,0,0,1,0,217.3Z","transform":"translate(1132.771 482.536) rotate(180)","key":1})]);
}

WhiteBgDetailInline.defaultProps = {"width":"1132.771","height":"482.536","viewBox":"0 0 1132.771 482.536"};

module.exports = WhiteBgDetailInline;

WhiteBgDetailInline.default = WhiteBgDetailInline;
